import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_BASE_URL || 'https://thalvora-exports.onrender.com';

export interface SEOData {
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string[];
  ogTitle: string;
  ogDescription: string;
  ogImage: string;
  twitterTitle: string;
  twitterDescription: string;
  twitterImage: string;
  canonicalUrl: string;
  robotsTxt: string;
  sitemapEnabled: boolean;
  analyticsId: string;
  googleVerification: string;
  bingVerification: string;
  structuredData: string;
  cacheTTL: number;
}

export const useSEO = (pageName: string) => {
  const [seo, setSeo] = useState<SEOData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/settings/seo/page/${pageName}`)
      .then(res => setSeo(res.data))
      .catch(err => console.error('SEO fetch failed:', err))
      .finally(() => setLoading(false));
  }, [pageName]);

  return { seo, loading };
};